<script>
	import Multiselect from "vue-multiselect";
	import { mapState, mapGetters } from "vuex";

	export default {
		components: {
			Multiselect
		},
		data() {
			return {
				openMenu: false,
				name: "",
				select_money_enabled: false
			};
		},
		computed: {
			...mapState({
				currencies: state => state.settings.currencies.sort((a,b) => {
					return a.iso.localeCompare(b.iso);
				}),
				app_path: state => state.app.app,
        is_superadmin: state => state.home.is_superadmin
			}),
			...mapGetters(['hasAccessToCurrencies']),
			currency: {
				get() {
					return this.$store.state.settings.currency;
				},
				set(value) {
					this.$store.commit("currency", value);
				}
			}
		},
		methods: {
			redirectToSubscriptionSelect () {
				top.window.location.href = `${this.app_path.url}settings/subscription/select/`;
			},
			codeWithName({ iso, name }) {
				return `${iso} — ${name}`
			}
		}
	};
</script>

<template>
	<div>
		<Multiselect
			v-if="hasAccessToCurrencies || is_superadmin"
			v-model="currency"
			:options="currencies"
			
			:custom-label="codeWithName"
			track-by="iso"
			:show-labels="false"
			:option-height="104"
			class="floating-model-menu"
			:multiple="false"
			:placeholder="$t('Nom ou code devise')"
		>
			<!-- Options on the select -->
			<template slot="option" slot-scope="props">
				<div class="option__desc">
					<span class="option__title"> {{ props.option.iso }} - {{ props.option.name }} </span>
				</div>
			</template>

			<template slot="singleLabel" slot-scope="props">
				<span class="option__desc">
					<span class="option__title"> {{ props.option.iso }} - {{ props.option.name }} </span>
				</span>
			</template>

			<template #noOptions>
				{{ $t("La liste est vide.") }}
			</template>

			<template slot="noOptions">
				{{ $t("La liste est vide.") }}
			</template>

			<template slot="noResult">
				{{ $t("Aucun résultat. Demandez au support d’ajouter la monnaie.") }}
			</template>
		</Multiselect>
		<div v-else>
			{{ $t("Passez sur un le plan ") }}
			<b-button variant="light" size="sm" @click="redirectToSubscriptionSelect"> {{ $t("Standard") }} <b-icon-star-fill font-scale="1.2" /></b-button>
			{{ $t("ou") }}
			<b-button variant="light" size="sm"  @click="redirectToSubscriptionSelect"> {{ $t("Pro") }} <b-icon-star-fill font-scale="1.2" /></b-button>
			{{ $t("pour pouvoir utiliser cette fonctionnalité et facturer dans l’une de ces devises !") }}
			<div class="currencies_info">
				<ul style="width: 100%; padding-left: 1rem; list-style-type: none">
					<li 
						v-for="money in currencies" 
						:key="money.iso"
					>
						- {{ money.name }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	.floating-model-menu {
		.option {
			&__title {
				align-items: center;
				display: flex;
			}

			&__desc {
				width: 100%;
				display: flex;
				justify-content: space-between;
			}

			&__trash.b-icon {
				font-size: 20px;
			}
		}

		.multiselect__option {
			padding: 10 px;
		}
	}
	.currencies_info {
		max-height: 5rem; 
		overflow-x: scroll;
		margin-top: 0.5rem; 
		padding: 0.5rem;
		border: 1px solid #eee;
		border-radius: 7px;
	}
</style>
